<template>
    <div
        v-if="guideTextNotEmpty"
        :class="['guide-component',
                 isMobile ? 'guide-component-small' : '']"
    >
        <div class="guide">
            <div>
                <img
                    :src="infoIcon"
                    :class="['info-icon']"
                    alt="infoAltText"
                >
            </div>
            <div>
                <!-- Huom oletetaan että Guidetext on HTML -->
                <h2
                    id="info"
                    class="visually-hidden"
                >
                    {{ infoAltText }}
                </h2>
                <span aria-describedby="info">{{ guideText }}</span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-facing-decorator"

    @Component
    export default class Guide extends Vue {
        @Prop({ type: String, default: "" }) guideText!: string
        @Prop({ type: Boolean, default: false }) isMobile!: boolean

        get infoIcon(): string {
            return this.$store.getters.contentServiceUrl + "/Content/icons/svg-blue/tieto.svg" + "?" + this.$store.getters.contentServiceTimeStamp
        }

        get infoAltText(): string | undefined {
            return this.$t("App.Guide.InfoIconAlt")
        }

        get guideTextNotEmpty(): boolean {
            return this.guideText !== undefined && this.guideText.length > 0
        }
    }
</script>

<style scoped>
    .guide-component {
        text-align: left;
        padding: 1.25rem;
        border-top: 5px solid #F4F6F9;
        background-color: #F2F4F8;
    }
    .guide-component-small {
        border: none;
        padding-top: 20px;
    }
    .guide-component-small > h1 {
        margin-top: 0px;
    }
    .guide {
        white-space: nowrap;
        display: flex;
    }
    .guide div:nth-child(1) {
        display: inline-block;
        vertical-align: top;
    }
    .guide div:nth-child(2) {
        display: inline-block;
        white-space: normal;
    }

    .info-icon {
        width: 20px;
        margin-right: 10px;
    }
</style>
